import React from 'react'
import PropTypes from 'prop-types'
import { getItemTypeConfig } from 'LiveBoard/components/shared/ItemType'
import { CollapsibleText } from 'LiveBoard/components/shared/CollapsibleText'
import { ItemModalActionButtons } from 'LiveBoard/components/shared/ItemModalActionButtons'

import './style.css.scss'

const MAX_CHARACTERS_DESCRIPTION_DESKTOP = 250

class Header extends React.Component {

  getActionButtons = () => {
    const {
      item, onOpenInNewTab, onLike, onDownload, blockDownload,
      isClassicTheme, onClose
    } = this.props

    const itemConfig = getItemTypeConfig(item, blockDownload)

    return {
      like: {
        iconClass: 'icon-like-empty',
        onClick: onLike,
        shouldDisplay: this.props.showLikes && !item.liked_by_user
      },
      likeFull: {
        iconClass: 'icon-like-full',
        shouldDisplay: this.props.showLikes && item.liked_by_user
      },
      newTab: {
        iconClass: 'icon-new-tab',
        onClick: onOpenInNewTab,
        shouldDisplay: itemConfig.canOpenInNewTab
      },
      download: {
        iconClass: 'icon-download',
        onClick: onDownload,
        shouldDisplay: itemConfig.canDownload
      },
      close: {
        iconClass: 'icon-close-thick',
        onClick: onClose,
        shouldDisplay: isClassicTheme
      }
    }
  }

  render() {
    const item = this.props.item || {}
    const classicVideoClassName = (this.props.isVideoItem && !this.props.isClassicTheme)
      ? 'below-content'
      : ''

    return (
      <section
        className={`header-wrapper ${classicVideoClassName}`} >
        <div className="header-content">
          <div className="top-bar-container">
            {
              item.category_name && !this.props.isClassicTheme &&
              <p className="item-category">
                {item.category_name || ""}
              </p>
            }
            <ItemModalActionButtons
              data={this.getActionButtons()}
              isLiveEventActive={this.props.isLiveEventActive}
              onClose={this.props.onClose} />
          </div>
          <h1>{item.name}</h1>
          { !this.props.isClassicTheme &&
            <CollapsibleText
              classNames={{
                container: "item-description-container" ,
                text: "item-description"
              }}
              text={item.description || ""}
              themeColorHex={this.props.themeColorHex}
              maxCharacters={MAX_CHARACTERS_DESCRIPTION_DESKTOP} />
          }
        </div>
      </section>
    )
  }
}

Header.propTypes = {
  item: PropTypes.object.isRequired,
  onLike: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onOpenInNewTab: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  blockDownload: PropTypes.bool,
  isLiveEventActive: PropTypes.bool,
  isVideoItem: PropTypes.bool,
  isClassicTheme: PropTypes.bool,
  themeColorHex: PropTypes.string.isRequired,
  showLikes: PropTypes.bool
}

export default Header
